import { appFullScreenSpinnerModel } from "@/shared/components/app-fullscreen-spinner/app-full-screen-spinner.model";
import { Vue } from "vue-property-decorator";

export class AppFullscreenSpinner extends Vue {
    model = appFullScreenSpinnerModel;
}
